import React, {useEffect, useState} from 'react'
import { Routes, Route, Navigate } from "react-router-dom";
//components
import Signup from '../components/signup';
//redux
import {useSelector} from 'react-redux';
import Dashboard from "../components/home";
import State from "../components/state";
import AllOrganData from "../components/home/AllOrganData";
import SchoolSignup from '../components/school-signup';

function Router() {
    const isLogin = useSelector(state => state.authentication.isLogin);
    const [redirect, setRedirect] = useState(false)

    useEffect(() => {
        isLogin &&
        setTimeout(() => {
            setRedirect(true)
        }, 1000);
    }, [isLogin])

  return (
    <Routes>
      
      {!isLogin ?
        <>
            <Route path='login/' element={<Signup />} />
            <Route path='*' element={<Navigate to="login/" replace />} />
        </> :
        <>
            <Route path='dashboard/' element={<Dashboard />} />
            <Route path='schools/signup/' element={<SchoolSignup />} />
            <Route path='organ-students-data/' element={<AllOrganData />} />
            <Route path='state/:slug/' element={<State />} />
            <Route path='*' element={<Navigate to="dashboard/" replace />} />
        </>
      }
    </Routes>
  )
}

export default Router